import { Col, ColProps } from "antd";
import styled from "styled-components";

export const DateCol = styled(Col) <ColProps>`
  .ant-form-item {
    margin-bottom: 0px;
  }
`;

export const ButtonCol = styled(Col) <ColProps>`
  width: 100%;

  .ant-btn {
    width: 100%;
  }
`;

export const DisabledText = styled.h5`
  font-size: 0.79rem;
  font-weight: 400;
  color: #BFBFBF;
`;
